import { useEffect } from "react";
import Breadcrumb from "../../../components/breadcrumb";
import Footer from "../../../components/footer";
import PageBackgroundPattern from "../../../components/PageBackgroundPattern";
import CanchasHeader from "../components/CanchasHeader";
import CanchasTimeline from "../components/CanchasTimeline";

function Canchas() {
    useEffect(() => {
        document.title = "Canchas";
    }, []);

    return (
        <div className="relative min-h-screen overflow-hidden bg-[#062a1a] pt-16">
            <PageBackgroundPattern />

            <main className="relative z-10 max-w-7xl mx-auto w-full px-4 md:px-10 pt-2 pb-8 md:pb-10">
                <Breadcrumb
                    items={[
                        { label: "Inicio", to: "/" },
                        { label: "Historia" },
                        { label: "Canchas", isCurrent: true },
                    ]}
                    className="mb-4"
                />

                <div>
                    <CanchasHeader />
                    <CanchasTimeline />
                </div>
            </main>

            <div className="relative z-10">
                <Footer />
            </div>
        </div>
    );
}

export default Canchas;
